import { render, staticRenderFns } from "./LayoutImageUploadArea.vue?vue&type=template&id=4c5a6aa6&scoped=true"
import script from "./LayoutImageUploadArea.vue?vue&type=script&lang=js"
export * from "./LayoutImageUploadArea.vue?vue&type=script&lang=js"
import style0 from "./LayoutImageUploadArea.vue?vue&type=style&index=0&id=4c5a6aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a6aa6",
  null
  
)

export default component.exports